/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_2_AInputs */



/**
* | output |
* | --- |
* | "The Guardrails feature is based on static pattern matching and does NOT perform semantic analysis or context-based evaluation" |
*
* @param {Guardrails_Section_2_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_2_a = /** @type {((inputs?: Guardrails_Section_2_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_2_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Guardrails-Funktion auf statischem Pattern-Matching basiert und KEINE semantische Analyse oder kontextbezogene Bewertung durchführt")
	return /** @type {LocalizedString} */ ("The Guardrails feature is based on static pattern matching and does NOT perform semantic analysis or context-based evaluation")
});